import { FieldDescriptor } from './types'

type ValueMap = Record<string, unknown>

const hasValue = (v: unknown) => v !== undefined && v !== null && v !== ''

/** Поле с `shownWith` показывается, только пока у того ключа есть значение. */
export const isFieldShown = (field: FieldDescriptor, values: ValueMap): boolean =>
  !field.shownWith || hasValue(values[field.shownWith])

/**
 * Поля с `shownWith` следуют за своим ключом: при первом его вводе получают `default`, без него
 * удаляются. Применяется к каждому изменению конфига и к профилю при открытии — так профиль,
 * сохранённый до появления поля, уходит на сохранение уже с ним.
 */
export const withShownWithDefaults = (values: ValueMap, catalog: FieldDescriptor[]): ValueMap => {
  const next = { ...values }
  catalog.forEach((f) => {
    if (!f.shownWith) return
    if (!hasValue(next[f.shownWith])) delete next[f.key]
    else if (!hasValue(next[f.key]) && f.default !== undefined) next[f.key] = f.default
  })
  return next
}
